'use client';

import { useQuery } from '@tanstack/react-query';
import { clients } from '../clients';
import { QueryKey } from './QueryKey';

export function useSpecificTeam(slug: string | null) {
  const {
    data: team,
    isLoading: teamLoading,
    isError: teamError,
  } = useQuery({
    queryKey: [QueryKey.Team, 'specific', slug],
    queryFn: async () => {
      const team = await clients.team.getSpecific({
        query: {
          slug: slug!,
        },
      });
      if ('error' in team) {
        throw new Error(team.error as string);
      }
      return team;
    },
    enabled: !!slug,
  });

  return { team, teamLoading, teamError };
}

export function useSpecificTeamReviews(teamId: number | null) {
  const {
    data: reviews,
    isLoading: reviewsLoading,
    isError: reviewsError,
  } = useQuery({
    queryKey: [QueryKey.Team, teamId, 'reviews'],
    queryFn: () => {
      return clients.team.getReviews({ args: { teamId: teamId! } });
    },
    enabled: !!teamId,
  });

  return {
    reviews,
    reviewsLoading,
    reviewsError,
  };
}
